"use client"

import { t } from "@/languages/i18n"
import { PublishProps } from "@/types/types"
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons"
import { Button, Space, Typography } from "antd"
import React, { useState } from "react"
import {
  DatePublish,
  LanguagePublish,
  StatusPublish,
  VisibilityPublish
} from "./StatusPublish"

const { Title } = Typography

const Publish: React.FC<PublishProps> = ({
  onSubmit,
  isCreateEdit,
  status,
  setStatus,
  language,
  setLanguages,
  setPublishDate,
  loading,
  type = "create",
}) => {
  const [isPublishListVisible, setPublishListVisible] = useState(true)

  return (
    <div className="publish border-gray-300 border rounded-[10px] mb-5 bg-white overflow-hidden shadow-sm">
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <Title level={4} className="!m-0 text-base font-semibold">
          {type === "translate" ? t("Tạo bản dịch") : t("Xuất bản")}
        </Title>
        <Button
          onClick={() => setPublishListVisible(!isPublishListVisible)}
          className="flex items-center"
          icon={isPublishListVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
          type="text"
        />
      </div>

      {isPublishListVisible && (
        <div>
          <Space direction="vertical" className="px-4 py-4 w-full" size="middle">
            <StatusPublish 
              status={status} 
              setStatus={setStatus} 
            />
            
            <LanguagePublish 
              language={language} 
              setLanguages={setLanguages!} 
              isCreateEdit={isCreateEdit} 
            />

            <VisibilityPublish 
              status={status === "Published" ? "Publish" : "Draft"} 
            />

            <DatePublish 
              setPublishDate={setPublishDate} 
            />
          </Space>

          <div className="flex justify-end border-t pt-3 px-4 bg-[#f6f7f7] rounded-b-[10px] h-14">
            <Button 
              type="primary" 
              onClick={onSubmit} 
              loading={loading}
            >
              {type === "translate"
                ? t("Tạo bản dịch")
                : status === "Draft"
                ? t("Lưu nháp")
                : isCreateEdit
                ? t("Xuất bản")
                : t("Cập nhật")}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Publish